import { LoadingCirculo } from "components/LoadingCirculo";
import { Container } from "./style";
import { useEffect, useState } from "react";
import { IEstatisticasPagamento } from "../../../../../interface/IEstatisticasPagamento";
import { formatarDinheiro } from "_utils/Money";

interface IProps {
  item: "custoProcesso" | "servicoReceber";
  id: number;
  estatisticasPagamento: IEstatisticasPagamento[];
}

export function LoadingEstatisticaDetalhe({
  item,
  id,
  estatisticasPagamento,
}: IProps) {
  const [valorMostrar, setValorMostrar] = useState<any>(null);

  useEffect(() => {
    const processoValor = estatisticasPagamento.find(
      (item) => item.idPagamento == id
    )?.[item];

    if (processoValor) {
      setValorMostrar(formatarDinheiro(Number(processoValor)));
      return;
    }

    setValorMostrar(estatisticasPagamento ? "-" : null);
  }, [estatisticasPagamento]);

  return (
    <Container>
      {valorMostrar ?? <LoadingCirculo mostrar height={1.5} />}
    </Container>
  );
}
